import Konva from 'konva';
import { Stage } from '@picsart/web-layering/types';
import {
  destroyNode,
  detachEventAllHandlers,
  findLayer,
  getNodeChildrenArray,
  setNodeAttrs,
  findNodeIdentifierToArray,
} from '@picsart/web-layering/rendering/konva/selectors';

import { scrollBarsLayerId } from 'configs/constants';

import { batchDrawNode } from './selectors';

const removeScrollLayersFromCanvas = (stage: Stage) => {
  const scrollLayers = findLayer(stage, `#${scrollBarsLayerId}`);

  if (!scrollLayers) {
    return;
  }

  detachEventAllHandlers(stage, 'wheel.scroll');
  getNodeChildrenArray(scrollLayers).forEach(scrollBar => detachEventAllHandlers(scrollBar, 'dragmove'));
  destroyNode(scrollLayers);

  const layers = findNodeIdentifierToArray(stage, el => el instanceof Konva.Layer);

  layers.forEach(layer => {
    setNodeAttrs(layer, {
      x: 0,
      y: 0,
    });
  });

  batchDrawNode(stage);
};

export default removeScrollLayersFromCanvas;
